var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17247 5.49902C5.02937 5.5079 4.88892 5.45639 4.78344 5.35636L0.669016 1.44351C0.530604 1.31125 0.4712 1.11295 0.513183 0.923326C0.555167 0.7337 0.692158 0.581556 0.872551 0.52421C1.05294 0.466865 1.24933 0.51303 1.38772 0.645315L5.14279 4.21511L8.89787 0.645315C9.03627 0.51303 9.23265 0.466865 9.41304 0.52421C9.59343 0.581556 9.73043 0.7337 9.77241 0.923326C9.81439 1.11295 9.75499 1.31125 9.61658 1.44351L5.50215 5.35636C5.41173 5.442 5.29513 5.49245 5.17247 5.49902Z",
    fill: "#417FFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrowDown);
export default __webpack_public_path__ + "static/media/accordion_arrow_down.17dd2f5c.svg";
export { ForwardRef as ReactComponent };